import { redirect } from 'react-router-dom';
// Concrete file, not the '@constants' barrel: that barrel pulls in '@utils' and
// the app store, whose boot-time code calls isEupRoute() — going through the
// barrel would read RL before it is initialised.
import { RouteLiterals as RL } from '@constants/route-literals';

const getEndingRoutePath = () => window.location.pathname.split('/').pop();

const isValidRoutePath = () => Object.values(RL).includes(getEndingRoutePath());

// The signed-in end-user portal: dashboard, profile selection and the auth
// callback. Everything else (consent / privacy / cookie centers, assessment
// forms) is a public, per-link flow.
const EUP_ROUTE_ROOTS = [RL.DASHBOARD, RL.SELECT_PROFILE, RL.AUTHENTICATE];

const isEupRoute = () => {
  let result = false;
  if (typeof window !== 'undefined') {
    const [root] = window.location.pathname.split('/').filter(Boolean);
    result = EUP_ROUTE_ROOTS.includes(root);
  }
  return result;
};

const isPublicRoute = () => (
  window.location.pathname.includes(RL.AUTHENTICATE)
  || getEndingRoutePath() === RL.REQUEST_RESPONSE
  || window.location.pathname.includes(RL.ASSESSMENT_RESPONDER_FORM_ROUTE)
  || window.location.pathname.includes(RL.ASSESSMENT_RESPONDER_FORM_LEGACY_ROUTE)
);

// Per-link pages rendered without the OAuth AuthProvider (RootLayout). Unlike
// isPublicRoute (auto-login), /authenticate is not here: it needs AuthProvider.
const AUTH_FREE_PATHS = ['/collect', '/privacy-center', '/cookie-center'];

const isAuthFreeRoute = (pathname) => AUTH_FREE_PATHS.includes(pathname)
  || pathname.includes(RL.ASSESSMENT_RESPONDER_FORM_ROUTE)
  || pathname.includes(RL.ASSESSMENT_RESPONDER_FORM_LEGACY_ROUTE)
  || pathname.startsWith(`/${RL.FEEDBACK}`);

// Route loader — redirects the legacy assessment URL to the new canonical path,
// preserving the raw signed query string (exp/credentialId/signature/userId/type)
// verbatim, before the form mounts (so its one-time query snapshot stays intact).
const assessmentLegacyRedirectLoader = ({ request, params }) => {
  const url = new URL(request.url);
  throw redirect(`${RL.ASSESSMENT_RESPONDER_FORM_ROUTE}${params.token}${url.search}`);
};

export {
  isEupRoute, isPublicRoute, isAuthFreeRoute, isValidRoutePath, assessmentLegacyRedirectLoader,
};
